<div class="dialog-content">

    <button
            *ngIf="data.closeButton"
            (click)="data.dialogHandles.close(defaultValues$.CANCEL)"
            mat-icon-button
            class="close-button">
        <mat-icon>close</mat-icon>
    </button>
    <h1 mat-dialog-title *ngIf="data.title && data.title.length > 0">{{ data.title }}</h1>

    <!-- Content Injection --><!-- Component Injection -->
    <div class="dialog-content-wrapper"
         [class.very-scrollable]="!!data.scrollAlwaysVisible"
         mat-dialog-content (scroll)="onScroll($event)"><ng-container *ngIf="!data.html">{{ data.message }}</ng-container><div *ngIf="data.html" [innerHTML]="data.message"></div><div style="white-space: normal;" #component></div></div>

    <!-- Input TODO: THIS WOULD BE BETTER AS COMPONENTS FOR EACH TYPE
     RSDialog.InputType.TEXT etc. -->
    <ng-container
            *ngIf="data.type === 'INPUT'"
            [ngSwitch]="true">

        <!-- inputTypes$.TEXT && inputTypes$.NUMBER -->
        <mat-form-field
                appearance="outline"
                style="min-width: 300px; display: block; padding-left: 20px; padding-right: 20px;"
                *ngSwitchCase="data.inputType === inputTypes$.NUMBER || data.inputType === inputTypes$.TEXT || data.inputType === inputTypes$.PASSWORD">
            <input
                    matInput
                    [placeholder]="data.inputPlaceholder"
                    [type]="(data.inputType === inputTypes$.NUMBER ? 'number' : (data.inputType === inputTypes$.PASSWORD ? 'password' : 'text'))"
                    [(ngModel)]="data.inputValue" />
        </mat-form-field>

        <!-- inputTypes$.TEXTAREA -->
        <mat-form-field
                appearance="outline"
                style="width: 100%; margin-top: 10px;"
                *ngSwitchCase="data.inputType === inputTypes$.TEXTAREA">
            <textarea
                    rows="2"
                    matInput
                    [placeholder]="data.inputPlaceholder"
                    [(ngModel)]="data.inputValue"></textarea>
        </mat-form-field>

        <!-- inputTypes$.SELECT -->
    </ng-container>

    <!-- Panel Injection -->
    <mat-expansion-panel
             class="rsdialogPanel"
             *ngIf="data.additional"
             (opened)="panelOpenState$ = true"
             (closed)="panelOpenState$ = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                More Info
            </mat-panel-title>
            <mat-panel-description>
                <!--Currently I am {{panelOpenState ? 'open' : 'closed'}}-->
            </mat-panel-description>
        </mat-expansion-panel-header>
        <p>{{data.additional}}</p>
    </mat-expansion-panel>

    <!-- Button Injection -->
    <ng-container *ngIf="(data.buttons && data.buttons.length > 0) || data.buttonTemplateRef">
        <div
            cdkTrapFocus
            style="margin-top: 10px;"
            mat-dialog-actions
            [ngSwitch]="true"
        >
            <ng-container
                *ngSwitchCase="data.buttons && data.buttons.length > 0"
            >
                <!-- [cdkFocusRegionStart]="i === 0"
                     [cdkFocusRegionEnd]="i === (data.buttons.length - 1)"
                     [cdkFocusInitial]="i === (data.buttons.length - 1)"
                     -->
                <button mat-button
                        [mat-dialog-close]="button.value"
                        [ngClass]="(button.style ? ('style' + data.styles[button.style]) : (data.style && i === (data.buttons.length - 1) ? 'style' + data.styles[data.style] : ''))"
                        *ngFor="let button of data.buttons; index as i">{{button.title}} <mat-icon *ngIf="button.icon && data.hasIcons">{{button.icon}}</mat-icon>
                </button>
            </ng-container>
            <ng-container
                    [ngTemplateOutlet]="data.buttonTemplateRef"
                    *ngSwitchCase="!!data.buttonTemplateRef"
            >
            </ng-container>
        </div>
    </ng-container>
</div>
